module.exports = __webpack_public_path__ + "img/edits-sub-category.b2ea9241.svg";